<template>
  <div v-if="currentUser" class="admin">
    <panel class="Meta">
      <h2>Meta</h2>

    </panel>
    <panel class="users">
      <h2>Users</h2>
      <div class="create-new">New</div>
      <div class="user" v-for="(user, index) in users" :key="index">
        <div class="user-wrapper">
          <img :src=user.avatar class="avatar">
          <div class="details">
            <div class="name">{{ user.displayName }}</div>
            <div class="email">{{ user.email }}</div>
            <div class="user-organisation">{{ user.organisation }}</div>
            <div class="uid">{{ user.id }}</div>
          </div>
        </div>
        <add-organisation-to-user-form :user="user"></add-organisation-to-user-form>
      </div>
    </panel>
    <panel class="organisations">
      <h2>Organisations</h2>
      <div class="create-new">New</div>
      <div class="organisation" v-for="(org, index) in organisations" :key="index">
        <div class="name">{{ org.name }}</div>
        <div class="uid">{{ org.id }}</div>
      </div>
    </panel>
    <organisation-form class="form"></organisation-form>
  </div>
</template>

<script>
import Panel from "@/components/layout/Panel"
import OrganisationForm from "../components/organisation/OrganisationForm"
import AddOrganisationToUserForm from "../components/user/AddOrganisationToUserForm"
export default {
  name: "settings",
  components: {
    Panel,
    OrganisationForm,
    AddOrganisationToUserForm
  },
  created() {
    if (!this.$store.getters.users) {
      this.$store.dispatch("getUsers");
    }
    if (!this.$store.getters.organisations) {
      this.$store.dispatch("getOrganisations");
    }
  },
  data() {
    return {
      currentUser: this.$store.getters.currentUser
    }
  },
  computed: {
    users() {
      return this.$store.getters.users
    },
    organisations() {
      return this.$store.getters.organisations
    }
  },
  methods: {
  }
};
</script>

<style lang="scss">
.admin {
  display: flex;
  margin-top: 30px;
  max-width: 500px;

  .user{
    border: 1px solid lightblue;
    border-radius: 8px;
    padding: 8px;
    .user-wrapper {
      display: flex;
    }
    img {
      height: 40px;
      margin-right: 4px;
    }
    .details {
    }
    .uid {
      font-size: 12px;
      color: grey;
      padding-bottom: 8px;
    }
  }

  .organisation {
    border: 1px solid lightblue;
    border-radius: 8px;
    padding: 8px;
    .uid {
      font-size: 12px;
      color: grey;
    }
  }
}
.panel {
  &:first-child {
    margin-left: 10px;
  }
  margin-right: 10px;
}


.form {
  min-width: 300px;
}
</style>